import { useQuery } from "@tanstack/react-query";
import { Form, Radio, Spin } from "antd";
import { useIntl } from "react-intl";
import { getTeamSize } from "../../network/onboarding";
import { queryKeys } from "../../services/react-query/queryKeys";
import RadioButtonTeam from "./RadioButtonTeam";

const TeamSize = ({ TeamData }: any) => {
  const circleSizes = [32, 28, 20, 16]; // Define sizes for each index
  const columnSpans = [1, 3, 4, 5]; // Define column spans for each index
  const { data: TeamSizeData, isLoading } = useQuery(
    [queryKeys?.listClient, queryKeys.listLocations],
    () => getTeamSize()
  );
  const intl = useIntl();
  return (
    <div className="w-full mx-auto text-center">
      <h3 className="!font-medium text-lg text-color-primary max-md:mb-4 max-md:text-base mb-6">
        {intl.formatMessage({
          id: "teamSizeQuestion",
        })}{" "}
      </h3>
      <Form.Item
        name="team_size_id"
        className="!p-0 mx-auto flex items-center justify-center"
        rules={[{ required: true, message: "اختار" }]}
        hasFeedback
      >
        {isLoading ? ( // Show loading animation if isLoading is true
          <Spin size="large" />
        ) : (
          <Radio.Group
            className="w-full max-md:gap-3 px-2 lg:py-4 !mb-0 !mx-auto max-xl:grid max-xl:grid-cols-2 border-none flex max-md:flex-col gap-8"
            buttonStyle="solid"
          >
            {TeamData?.map((e: any, i: any) => {
              const { id, name, min_size, max_size } = TeamSizeData?.data[i];

              const size = circleSizes[i] || 3;
              const col = columnSpans[i] || 3;

              return (
                <RadioButtonTeam
                  {...e}
                  id={id}
                  name={name}
                  min_size={min_size}
                  max_size={max_size}
                  size={size}
                  col={col}
                  index={i}
                  key={i}
                />
              );
            })}
          </Radio.Group>
        )}
      </Form.Item>
    </div>
  );
};

export default TeamSize;
